export interface ForemanEquipmentUsage {
  foremanEquipmentUsageID: string;
  foremanEquipmentDispatchID: string;
  dateUsed: Date;
  foremanPhaseID: string;
  shift: number;
  foremanJobCrewID: string;
  quantity: number;
  amount: number;
  bActive: boolean;
  notUsed: boolean;
  foremanNotes: string;
  isChanged: boolean;
}
